export default "__VITE_ASSET__7f91645d__"